export enum PasswordStrength {
	Weak = 'Too Weak',
	Close = 'Getting Close',
	Strong = 'Strong',
}
